module.exports = __webpack_public_path__ + "86218e81728b3ab08dd9c1111c8c9ae2.svg";